<script>
    import Dialog from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/Dialog.svelte?1733898724755';
    import { price_request } from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/store.js?1733898724755';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724755';

    wyvr: {
        render: 'hydrate';
        loading: 'interact';
        trigger: 'trigger_price_request';
    }

    export let product;

    $: id = get_attribute_value(product, 'entity_id');
    $: requested = $price_request.indexOf(id) > -1;

    let open = false;
</script>

<div class="c-product-price-request">
    {#if requested}
        <div>{window.__('price_request.success')}</div>
    {:else}
        <button class="btn btn--price-request btn--green" on:click={() => (open = true)}
            >{window.__('price_request.action')}</button
        >
        <div>{window.__('price_request.description')}</div>
    {/if}
</div>

{#if true}
    {#if open}
        <Dialog {product} bind:open />
    {/if}
{/if}
